module.exports = __webpack_public_path__ + "assets/img/FPS.b1872018.png";